import { render, staticRenderFns } from "./EchartRiver.vue?vue&type=template&id=363629fe&scoped=true"
import script from "./EchartRiver.vue?vue&type=script&lang=js"
export * from "./EchartRiver.vue?vue&type=script&lang=js"
import style0 from "./EchartRiver.vue?vue&type=style&index=0&id=363629fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363629fe",
  null
  
)

export default component.exports